import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.auth.edit.config.isLoading;
}

export default editIsLoading;
